export default __webpack_public_path__ + "static/media/swapIcon1.3441be00.svg";